module.exports = __webpack_public_path__ + "h5/img/lazhusingle.35fa72db.png";